import type { ThemeTokens } from "./tokens.ts";

const twipsToMm = (twips: number) => (twips / 1440) * 25.4;

/** Seeded "Klarity Technical" tokens: exact conversions of packages/render/test/oracle/klarity-doc.cjs. */
export const klarityTokens: ThemeTokens = {
  colors: {
    primary: "#607D3B",
    accent: "#E8873A",
    text: "#2C2C2C",
    muted: "#888888",
    code: "#555555",
    border: "#D0D0D0",
    stripe: "#F5F5F5",
    caption: "#D8E8C5",
    noteFill: "#EEF3E8",
    warnFill: "#FDF1E7",
    white: "#FFFFFF",
  },
  fonts: { body: { family: "Arial", source: "system" }, mono: { family: "Courier New", source: "system" } },
  sizes: {
    body: 10,
    table: 9,
    group: 8.5,
    groupTitle: 9.5,
    groupMeta: 8,
    code: 7.5,
    small: 8,
    title: 28,
    h1: 13,
    h2: 11,
    coverSubtitle: 16,
    coverDocType: 12,
  },
  page: { size: "A4", marginMm: 19.05, headerMm: twipsToMm(708), footerMm: twipsToMm(708) },
  spacing: {
    after: { h1: 7, h2: 4, p: 3, kv: 3, bullets: 3, steps: 3, code: 2 },
    firstBefore: { h1: 20, h2: 12 },
    gap: {
      afterH1: 30.5,
      afterH2: 14.5,
      h1AfterTable: 20,
      h1AfterText: 23,
      h2AfterTable: 30.5,
      h2AfterText: 32.5,
      pAfterP: 20.5,
      textAfterText: 21.5,
      aroundTable: 19.5,
    },
  },
  table: { headerFill: "primary", stripes: true, borderColor: "border", cellPadding: { v: 5, h: 7 } },
  logos: { cover: "builtin:klarity-logo", header: "builtin:klarity-logo" },
  labels: {
    en: {
      internal: "Klarity — Internal Use Only",
      clientCover: "Confidential — prepared for {client}",
      clientFooter: "Klarity BV · info@klarity.be · Confidential",
      page: "Page",
      contents: "Contents",
      note: "Note",
      warning: "Warning",
    },
    nl: {
      internal: "Klarity — Enkel voor intern gebruik",
      clientCover: "Vertrouwelijk — opgesteld voor {client}",
      clientFooter: "Klarity BV · info@klarity.be · Vertrouwelijk",
      page: "Pagina",
      contents: "Inhoud",
      note: "Opmerking",
      warning: "Let op",
    },
  },
};
